/* eslint-disable react/prop-types */
import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { Button } from 'foundations-library/components'
import { ButtonType } from 'foundations-library/types'
import { EsimContext } from 'providers'
import { NavigationContext } from 'navigation'
import { listing as listTexts } from './../../../utils/objects'
import { routeToAddEsim } from '../../../utils'

const useStyles = makeStyles({
    root: {}
})

/**
 *
 */
const AddButton = (props: ButtonType) => {
    const classes = useStyles()
    const history = useHistory()
    const { app } = useContext(EsimContext)
    const { getPathToNavItem } = useContext(NavigationContext)

    const goToAddEsim = () => routeToAddEsim(getPathToNavItem, app, history)

    return (
        <div className={classes.root}>
            <Button size='medium' color='primary' variant='outlined' icon='add' onClick={goToAddEsim} {...props}>{props.children || listTexts.addButton}</Button>
        </div>
    )
}

export default AddButton
